export const ZONES_RESET_STATE = 'ZONES_RESET_STATE';
export const ZONES_CURRENT_ITEM = 'ZONES_CURRENT_ITEM';

export const ZONES_REQUEST_LOADING = 'ZONES_REQUEST_LOADING';
export const ZONES_REQUEST_SUCCESS = 'ZONES_REQUEST_SUCCESS';
export const ZONES_REQUEST_FAILED = 'ZONES_REQUEST_FAILED';

export const ZONES_CURRENT_ACTION = 'ZONES_CURRENT_ACTION';
export const ZONES_RESET_ACTION = 'ZONES_RESET_ACTION';